<script lang="ts" setup>
import PhoneInput from "../PhoneNumber/basePhoneInput/components/PhoneInput.vue";
import { useFocus } from "@vueuse/core";
import FlagComponent from "./FlagComponent.vue";
import { onMounted, ref, useAttrs } from "vue";
import { Input } from "@/components/ui/input";
const phoneInput = ref(null);
const { focused } = useFocus(phoneInput);
const attrs = useAttrs();

onMounted(() => {
	if (attrs.autofocus) {
		// Dynamic mount (e.g. email→phone switch): native autofocus won't run
		requestAnimationFrame(() => {
			focused.value = true;
		});
	}
});
</script>

<template>
	<PhoneInput noUseBrowserLocale
				fetchCountry
				class="flex"
				country-locale="en-EN">

		<template #selector="{
			inputValue,
			updateInputValue,
			countries
		}">
			<div class="relative">
				<!-- <Button type="button"
						variant="outline"
						class="flex gap-1 rounded-e-none rounded-s-lg px-3 pointer-events-none">
					<FlagComponent :country="inputValue" />
					<ChevronsUpDown class="-mr-2 h-4 w-4 opacity-50" />
				</Button> -->
				<span class="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
					<FlagComponent :country="inputValue" />
				</span>
				<select @change="(e) => {
					updateInputValue((e.target as HTMLSelectElement).value as any);
					focused = true;
				}"
						class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-10 max-w-10">
					<option value=""
							disabled>
						Select
					</option>
					<option v-for="option in countries"
							:key="option.iso2"
							:selected="option.iso2 === inputValue"
							:value="option.iso2">
						{{ option.name }}
						{{ option.dialCode }}
					</option>
				</select>
			</div>
		</template>

		<template #input="{ inputValue, updateInputValue, placeholder }">
			<Input ref="phoneInput"
				   class="rounded-e-lg rounded-s-none"
				   type="text"
				   autocomplete="shipping tel"
				   :model-value="inputValue"
				   @input="updateInputValue"
				   :placeholder="placeholder"
				   :name="$attrs.fieldName"
				   v-bind="{ ...$attrs }" />
		</template>
	</PhoneInput>
</template>
